export const TAG_TYPES = {
  circus: 0,
  midasPlus: 1,
  tamper: 2,
  dna: 3
};
